import React from 'react';
import { InertiaLink } from '@inertiajs/inertia-react';
import classNames from 'classnames';
import Icon from '@/Shared/Icon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {PREFIX_NAME_MANAGER_ROUTING} from '@/constants/Site'

export default ({ icon, href, link, text, exact }) => {
	const isActive = route().current(link + '*');

	const iconClasses = classNames('w-4 h-4 mr-2', {
	'text-white fill-current': isActive,
	'text-indigo-400 group-hover:text-white fill-current': !isActive
	});

	const textClasses = classNames({
	'text-white': isActive,
	'text-indigo-200 group-hover:text-white': !isActive
	});

	/*if (icon) icon = typeof icon === "string" ? <Icon name={icon} className={iconClasses} /> : <FontAwesomeIcon icon={icon} className={iconClasses} />;*/
	const IconComp = typeof icon === "string" ? Icon : FontAwesomeIcon;
	const iconProps = {...(typeof icon === "string" ? {name: icon} : {icon}), className: iconClasses}
	if (link && !exact) link = PREFIX_NAME_MANAGER_ROUTING + link;
  return (
    <div className="">
      <InertiaLink href={href||route(link)} className="flex items-center group py-2 pl-2">
        {icon && <IconComp {...iconProps} /> }
        <div className={textClasses}>{text}</div>
      </InertiaLink>
    </div>
  );
};
